/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const hedera_chain_about = () => `Hedera operates as a public network employing the hashgraph consensus algorithm for rapid and secure transaction validation. Governed by a council of esteemed organizations, Hedera ensures consistent progress and decentralization. Distinguished by its high throughput, security, and fair transaction ordering, Hedera strives to establish a trust layer for the internet.`
